// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__+tFuy","employee-header-item":"Header_employee-header-item__vEmZ1"};